var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoSelectAll(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/filled/content/select_all_24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,5 L5,5 L5,3 C3.9,3 3,3.9 3,5 Z M3,13 L5,13 L5,11 L3,11 L3,13 Z M7,21 L9,21 L9,19 L7,19 L7,21 Z M3,9 L5,9 L5,7 L3,7 L3,9 Z M13,3 L11,3 L11,5 L13,5 L13,3 Z M19,3 L19,5 L21,5 C21,3.9 20.1,3 19,3 Z M5,21 L5,19 L3,19 C3,20.1 3.9,21 5,21 Z M3,17 L5,17 L5,15 L3,15 L3,17 Z M9,3 L7,3 L7,5 L9,5 L9,3 Z M11,21 L13,21 L13,19 L11,19 L11,21 Z M19,13 L21,13 L21,11 L19,11 L19,13 Z M19,21 C20.1,21 21,20.1 21,19 L19,19 L19,21 Z M19,9 L21,9 L21,7 L19,7 L19,9 Z M19,17 L21,17 L21,15 L19,15 L19,17 Z M15,21 L17,21 L17,19 L15,19 L15,21 Z M15,5 L17,5 L17,3 L15,3 L15,5 Z M7,17 L17,17 L17,7 L7,7 L7,17 Z M9,9 L15,9 L15,15 L9,15 L9,9 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/filled/content/select_all_24px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/content/select_all_24px",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "white",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-\\uD83D\\uDC49Icon-Style"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSelectAll);
export default __webpack_public_path__ + "static/media/ico_select_all.747c16d6561e5b4e2a681650a92f70b5.svg";
export { ForwardRef as ReactComponent };